const checkColorTheme = (color) => {
  const checkColor = color.slice(0, 1)
  return checkColor === '#' ? 'blue' : color
}

export default checkColorTheme
